import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { Text } from "~/foundation/components/Text";

/**
 * A signpost, not a second console.
 *
 * The windows themselves live at `/console/ides` because watching is not configuring, and
 * duplicating the console here would give two places for the same truth to be stale in. The
 * section still exists so the surface is findable from settings search — and so the legacy
 * `/settings/connected-ides` deep link, which the `ide.connected` notification already sends
 * people to, lands somewhere that makes sense.
 */
export function ConnectedIdes() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-2">
      <Text variant="small">
        {t("Your connected editor windows live in the IDE Console, where you can watch them.")}
      </Text>
      <Link to="/console/ides" className="text-body text-accent hover:underline">
        {t("Open the IDE Console")}
      </Link>
    </div>
  );
}
